import { Table, Text, Time } from "@sembark-travel/ui-base"
import { ListView, Search, useSearch } from "@sembark-travel/ui-list"
import { useLocationQuery } from "@sembark-travel/ui-router"
import { useEffect } from "react"
import { TWorldCurrencyExchangeRate, worldXHR } from "../../World"

export function CurrencyExchangeRatesList({
	baseCurrency,
}: {
	baseCurrency?: string
}) {
	const [query, setQuery] = useLocationQuery()
	const [searchParams, setSearchParams] = useSearch(query)
	useEffect(() => {
		setQuery(searchParams)
	}, [searchParams, setQuery])
	return (
		<Search
			title="Currency Exchange Rates"
			initialParams={searchParams}
			onSearch={(params) => setSearchParams(params)}
		>
			{() => (
				<ListView<TWorldCurrencyExchangeRate>
					pageKey="admin/world/currency-exchange-rates"
					params={searchParams}
					onPageChange={(page) => setSearchParams({ ...searchParams, page })}
					fetch={(xhr, params) =>
						worldXHR(xhr).getCurrencyExchangeRates({
							base_currency: baseCurrency || null,
							...params,
						})
					}
				>
					{({ items }) => (
						<Table
							headers={["Base", "Counter", "Rate", "Last Fetched"]}
							responsive
							hover
							bordered
							rows={items.map((item) => [
								item.base_currency,
								item.counter_currency,
								<Text fontFamily="mono">{item.rate}</Text>,
								<Time timestamp={item.fetched_at} />,
							])}
						/>
					)}
				</ListView>
			)}
		</Search>
	)
}
